// Tokens for the Figma frame "VIP / bonuses / arcade games" (3618:68740) - page "PAVEL DRAFT",
// section "bonuses". It is drawn on the same 390-wide mobile frame as the event dashboard, with
// a 370-wide content column, so every number in this folder is in that design space and is
// scaled once by the screen.
//
// Unlike the event dashboard, these are not inferred: they are the file's own values, read off
// the components with get_design_context. The named colours are its variables (text/primary,
// text/accent, text/secondary, gold/50..gold/300, surface/overlay, radius/sm, radius/md) and the
// gradients and shadows below are the exact fills the masters paint.
import { EVENT_FONT, EVENT_FONT_CONDENSED } from '../Event/eventTheme';

export const BONUS_FONT = EVENT_FONT;
/** The file sets titles in Sofia Sans Condensed; the app bundles Semi Condensed. */
export const BONUS_FONT_CONDENSED = EVENT_FONT_CONDENSED;

export const DESIGN_FRAME_WIDTH = 390;
/** Every block on the frame is 370 wide, centred in the 390 frame. */
export const DESIGN_CONTENT_WIDTH = 370;
/** Daily bonus -> featured games -> VIP section all sit 8 apart. */
export const DESIGN_SECTION_GAP = 8;
/** Wider viewports centre the column rather than stretching it, same cap as the home redesign. */
export const MAX_SCALE = 1.15;

export const bonusColors = {
	/** text/primary */
	primary: '#FFFFFF',
	/** text/accent - card titles, prize figures, the current day. */
	accent: '#FFFF99',
	/** text/secondary */
	secondary: '#D9C4BC',
	/** gold/50 - the collected day's label, and every green button's text. */
	gold50: '#FFF5B9',
	/** gold/100 - the collected day's amount. */
	gold100: '#FFE9A8',
	/** gold/150 - the DAILY BONUS heading. */
	gold150: '#FFEE82',
	/** gold/300 - the current day's ring and the NEW badge outline. */
	gold300: '#FFC500',
	/** surface/overlay - the NEW badge plate. */
	surfaceOverlay: '#4A1A0E',
	/** The card frames' bright gold hairline. */
	cardBorder: '#FFF908',
	/** Section plates are outlined in the duller orange. */
	sectionBorder: '#DA600E',
	/** The flat plate the daily-bonus strip is filled with. */
	stripSurface: '#330E07',
	/** The dimmed chip outline shared by the collected and locked days. */
	chipDimBorder: 'rgba(255,140,31,0.35)',
	/** The locked day's label and amount. */
	locked: '#9A9A62',
} as const;

/** radius/sm and radius/md off the frame's variables. */
export const RADIUS_SM = 4;
export const RADIUS_MD = 8;
/** The day chip is a pill, not a rounded box. */
export const RADIUS_PILL = 39;
/** The section plates and the daily-bonus strip. */
export const RADIUS_SECTION = 10;

/** The featured card and the current day's chip: linear-gradient(180deg, #770700, #320400 80%). */
export const CARD_FILL: Array<[string, string]> = [
	['0', '#770700'],
	['0.80127', '#320400'],
	['1', '#320400'],
];
/** The compact card runs a shallower ramp than the featured one. */
export const COMPACT_CARD_FILL: Array<[string, string]> = [
	['0', '#571405'],
	['1', '#1F0503'],
];
/** The collected and locked day chips. */
export const CHIP_DIM_FILL: Array<[string, string]> = [
	['0', '#330B05'],
	['1', '#0F0402'],
];

const glow = (color: string, opacity: number, radius: number) =>
	({
		shadowColor: color,
		shadowOffset: { width: 0, height: 0 },
		shadowOpacity: opacity,
		shadowRadius: radius,
		elevation: Math.round(radius * 0.8),
	}) as const;

export const bonusGlow = {
	/** The cards: drop-shadow 0 0 10 #FF7200. */
	card: glow('#FF7200', 1, 10),
	/** The current day's chip: drop-shadow 0 0 5 #FF7200. */
	chip: glow('#FF7200', 1, 5),
	/** Section plates: 0 0 5 rgba(255,178,26,0.55). */
	section: glow('#FFB21A', 0.55, 5),
} as const;
